<template>
  <el-dialog
    title
    :visible.sync="show"
    :close-on-click-modal="false"
    width="550px"
    class="edit-modal"
    @close="onChange"
  >
    <div slot="title">
      {{ drawRow.type === 'add' ? $t('shop-site::facebook::add_title') : $t('shop-site::facebook::edit_title') }}
      <span v-show="drawRow.type === 'add'">
        <i class="icon-a-01wenhao iconfont-el"></i>
        <el-button type="text" @click="toGuider" style="font-size: 12px; padding: 0">
          {{ $t('shop-site::facebook::tip') }}
        </el-button>
      </span>
    </div>

    <el-form class="user-body" ref="form" :model="params" :rules="rules" label-width="120px" v-loading="loading">
      <el-form-item :label="$t('shop-site::facebook::table_shop') + '：'" prop="shopId">
        <el-select
          :popper-append-to-body="false"
          v-model="params.shopId"
          filterable
          class="input-item"
          :placeholder="$t('shop-site::facebook::placeholder_shop')"
          ref="shopSelect"
        >
          <el-option v-for="item in shopIds" :key="item.value" :label="item.label" :value="item.value"></el-option>
          <template slot="empty">
            <div class="empty-wrap">
              {{ $t('shop-site::facebook::dialog_noData') }}
              <el-button type="text" style="margin-left: 10px" @click="toBindShop">
                {{ $t('shop-site::facebook::dialog_bind') }}
              </el-button>
            </div>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('shop-site::facebook::table_account') + '：'" prop="accountName">
        <el-input
          :placeholder="$t('shop-site::facebook::placeholder_account')"
          class="input-item"
          v-model.trim="params.accountName"
          maxlength="50"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('shop-site::facebook::table_accountId') + '：'" prop="accountId">
        <el-input
          :placeholder="$t('shop-site::facebook::placeholder_accountId')"
          class="input-item"
          v-model.number="params.accountId"
          maxlength="20"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('shop-site::facebook::button_token') + '：'" prop="tokenId">
        <el-select
          :popper-append-to-body="false"
          v-model="params.tokenId"
          filterable
          class="input-item"
          :placeholder="$t('shop-site::facebook::placeholder_token')"
          style="width: 94%"
        >
          <el-option v-for="item in tokens" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <i class="iconfont iconadd" @click="showAddToken = true" v-auth="'stores::shop-site::fb-token'"></i>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onChange">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="onSave" :loading="saveLoading">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
    <EditDialog ref="edit" :isNew="true" @editAndadd="getShopListInfo"></EditDialog>
    <tokenModal v-model="showAddToken" @close="getTokenList"></tokenModal>
  </el-dialog>
</template>
<script>
import { getTokenAdsList, accountSaveOrUpdate } from '@/server/marketing.js'
import { getShopList, getErpShopList } from '@/server/shopList.js'
import tokenModal from './token-modal'
import EditDialog from '@/views/store/components/editDialog'
export default {
  name: 'edit-modal',
  components: { EditDialog, tokenModal },
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      default: false,
    },
    drawRow: {
      default: () => {},
    },
  },
  watch: {
    visible(bool) {
      this.show = bool
      const data = this.drawRow
      if (bool) {
        this.getShopListInfo()
        this.getTokenList()
      }
      if (data.type === 'add') {
        this.params = {
          shopId: '',
          id: null,
          accountId: '',
          tokenId: '',
          accountName: '',
        }
      } else {
        this.params = {
          shopId: data.item.shopId,
          id: data.item.id,
          accountId: Number(data.item.accountId),
          tokenId: data.item.tokenId,
          accountName: data.item.accountName,
        }
      }

      this.$nextTick(() => this.$refs.form.clearValidate())
    },
    drawRow: {
      handler: function (data) {},
      deep: true,
    },
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      showAddToken: false,
      shopIds: [],
      tokens: [],
      rules: {
        shopId: [{ required: true, message: this.$t('shop-site::facebook::placeholder_shop'), trigger: 'change' }],
        accountId: [
          { required: true, message: this.$t('shop-site::facebook::placeholder_accountId'), trigger: 'change' },
          {
            required: true,
            type: 'number',
            message: this.$t('shop-site::facebook::placeholder_number'),
            trigger: 'change',
          },
        ],
        accountName: [
          { required: true, message: this.$t('shop-site::facebook::placeholder_account'), trigger: 'change' },
        ],
        tokenId: [{ required: true, message: this.$t('shop-site::facebook::placeholder_token'), trigger: 'change' }],
      },
      show: false,
      params: {},
      merchantId: this.$store.state.user.merchantId,
    }
  },
  computed: {
    sourceType() {
      return this.$store.state.user.sourceType
    },
  },
  mounted() {},
  methods: {
    toGuider() {
      window.open('https://docs.qq.com/doc/DTFZnd1dBTkFuWGZS', '_blank')
    },
    async getShopListInfo() {
      this.loading = true
      if (this.sourceType === 1) {
        const { data } = await getShopList({ pageSize: 10000, pageNum: 1 })
        if (data.code === this.$code) {
          this.shopIds = data.data.items.map(item => {
            return {
              label: item.name,
              value: item.id,
            }
          })
        }
      } else if (this.sourceType === 2) {
        const { data } = await getErpShopList(this.merchantId)
        if (data.code === this.$code) {
          this.shopIds = data.data.map(item => {
            return {
              label: item.shopName,
              value: item.shopId,
            }
          })
        }
      }
      // const { data } = await getShopList({ pageSize: 10000, pageNum: 1 })
      // if (data.code === this.$code) {
      //   console.log(data)
      //   this.shopIds = data.data.items.map(item => {
      //     return {
      //       label: item.name,
      //       value: item.id
      //     }
      //   })
      // }
      this.loading = false
    },
    async getTokenList() {
      this.loading = true
      const { data } = await getTokenAdsList()
      if (data.code === this.$code) {
        console.log(data)
        this.tokens = data.data.map(item => {
          return {
            label: item.appName,
            value: item.id,
          }
        })
      }
      this.loading = false
    },
    onChange() {
      this.$emit('change', false)
    },
    onSave() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.saveLoading = true
          let params = {
            ...this.params,
          }
          if (this.drawRow.type === 'add') {
            delete params.id
          }
          const { data } = await accountSaveOrUpdate(params)
          if (data.code === this.$code) {
            if (this.drawRow.type === 'add') {
              await this.$store.dispatch('getBindData')
            }
            this.$message.success(this.$t('system::tip::control_success'))
            this.$emit('save')
            this.$emit('change', false)
          }
          this.saveLoading = false
        }
      })
    },
    handleCheck(type) {
      this.$refs.form.resetFields()
      this.params.type = type
    },
    toBindShop() {
      this.$refs.shopSelect.blur() // 失焦隐藏下拉框
      this.$refs.edit.show()
    },
  },
}
</script>
<style lang="scss" scoped>
.edit-modal {
  .user-body {
    .input-item {
      width: 100%;
    }
  }
  .check-info {
    margin-bottom: 10px;
  }
  .tip-info {
    color: $--color-info;
  }
}
.empty-wrap {
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.icon-a-01wenhao {
  margin-left: 5px;
  font-size: 12px;
  color: #999;
}
.iconadd {
  margin-left: 5px;
  font-size: 16px;
  color: #dcdfe6;
  cursor: pointer;
  line-height: 31px;
}
</style>
